import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import CharacterImage from '../components/common/CharacterImage';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted">
      <Card className="border-border shadow-[var(--shadow-card)] w-full max-w-md">
        <CardHeader className="text-center">
          <CharacterImage slot="linkError" alt="링크 오류" className="mx-auto w-32 max-w-full h-auto mb-4" />
          <CardTitle className="text-2xl font-bold text-foreground">
            페이지를 찾을 수 없습니다
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-muted-foreground">
            요청하신 페이지가 존재하지 않거나 이동되었을 수 있습니다.
          </p>
          <div className="space-y-2">
            <Button asChild className="w-full">
              <Link to="/">
                대시보드로 돌아가기
              </Link>
            </Button>
            <Button variant="outline" asChild className="w-full">
              <Link to="/promotions">
                프로모션 목록으로 이동
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
